// extracted by mini-css-extract-plugin
export default {"fail_d":"Failed_fail_d__k6F21","fail_l":"Failed_fail_l__4l6vW","fail":"Failed_fail__rQz8Q"};